// Angular
import {Provider} from '@angular/core';

import {PrefixStoreService} from './prefix-store.service';
import {RegistrationStoreService} from './registration-store.service';
import {SimpleSendStoreService} from './simple-send-store.service';

const storeServices = [
  PrefixStoreService,
  RegistrationStoreService,
  SimpleSendStoreService,
];

export const storeProviders: Provider[] = [
  ...storeServices,
];
